import {
    ToggleEmployeeShouldSign,
    ToggleEmployeeShouldSignVariables,
} from "_graphql/visal/mutations/__generated__/ToggleEmployeeShouldSign";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { toggleEmployeeShouldSign } from "_graphql/visal/mutations/employee";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";
import { useEmployee } from "hooks/data/use-employees";

export default function AlertToSignContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const searchParams = useSearch<LocationGenerics>();
    const employeeId = searchParams?.id || "";
    const { employee, loading: employeeLoading } = useEmployee({
        employeeId,
    });
    const currentShouldSign = employee?.should_sign === true;
    const nextShouldSign = !currentShouldSign;

    const [toggle, { loading }] = useMutation<
        ToggleEmployeeShouldSign,
        ToggleEmployeeShouldSignVariables
    >(toggleEmployeeShouldSign, {
        refetchQueries: ["Employees"],
    });

    const handleSubmit = async () => {
        await toggle({
            variables: {
                employeeId,
                shouldSign: nextShouldSign,
            },
        }).then(({ data }) => {
            if (data?.toggleEmployeeShouldSign) {
                toast.success(
                    nextShouldSign
                        ? "Employee has been alerted to sign"
                        : "Signing alert removed successfully",
                );
                refetch?.();
                setOpen?.(false);
            } else {
                toast.error("Failed to update signing alert");
            }
        });
    };

    return (
        <PopUp
            open={open}
            setOpen={setOpen}
            title={
                currentShouldSign
                    ? "Remove Signing Alert"
                    : "Alert Employee to Sign"
            }
            cancelText={
                currentShouldSign
                    ? "No, Keep Signing Alert"
                    : "No, Don't Alert Employee"
            }
            variant="warning"
            description={
                currentShouldSign
                    ? "This will remove the signing requirement for this employee. They will no longer see signature options on their profile."
                    : "This will alert the employee to add or update their signature. They will see signature options on their profile page."
            }
            renderActions={() => (
                <button
                    type="button"
                    disabled={loading || employeeLoading}
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-600 text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={handleSubmit}>
                    {loading
                        ? currentShouldSign
                            ? "Removing Signing Alert..."
                            : "Alerting Employee..."
                        : currentShouldSign
                          ? "Yes, Remove Signing Alert"
                          : "Yes, Alert Employee to Sign"}
                </button>
            )}
        />
    );
}
